<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18Rvsod/image/cover.jpg?1731429783720" alt="This image is the cover for the book Spirits Unveiled"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spirits Unveiled
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Connect with the Spirits among Us</b></p><p>From ancestors and animal spirits to elementals and extraterrestrials, <i>Spirits Unveiled</i> presents an impressive variety of energetic beings. Each chapter features a particular kind of spirit and teaches you how to sense its presence, identify and connect with it, and set any boundaries you may need. Spirits are all around us, whether we realize it or not. Michelle Welch demystifies concepts and debunks misconceptions about different entities, helping you interact with them in healthy ways. She introduces you to both inspirational spirits like angels and guides as well as scarier beings like ghosts and demons. You'll learn how to scry with elementals, connect with an ascended master, protect against psychic attacks, astral travel, and more. Providing meditations, visualizations, and inspiring stories, this book helps boost your intuition and spiritual experience.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Welch
      </h2>
      
      <p class="authorDescription body article"><P><B>Michelle Welch</B> (Dallas, TX) is the owner and operator of the SoulTopia LLC metaphysical stores, where she provides intuitive readings and healing sessions in addition to teaching classes on crystals, tarot, energy work, and intuition. She has also presented at Readers Studio, the Northwest Tarot Symposium, and the International New Age Trade Show. Michelle is also an attorney and the host of the <I>SoulWhat</I> podcast and the <I>Michelle SoulTopia</I> YouTube channel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53346696